import { render, staticRenderFns } from "./table-percentile.component.html?vue&type=template&id=4e5619cd&scoped=true&"
import script from "./table-percentile.component.ts?vue&type=script&lang=ts&"
export * from "./table-percentile.component.ts?vue&type=script&lang=ts&"
import style0 from "./table-percentile.component.scss?vue&type=style&index=0&id=4e5619cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5619cd",
  null
  
)

export default component.exports